document.documentElement.classList.remove('no-js');

document.addEventListener('change', (event) => {
  const el = event.target;
  if (el.matches('[data-localization-select]')) {
    const form = el.closest('form');
    if (form) form.submit();
  }

  if (el.matches('[data-variant-select]')) {
    const option = el.options[el.selectedIndex];
    const root = el.closest('.product__info');
    if (!root || !option) return;

    const priceEl = root.querySelector('[data-product-price]');
    const compareEl = root.querySelector('[data-product-compare]');
    const addBtn = root.querySelector('[data-add-to-cart]');
    const isAvailable = option.dataset.available === 'true';

    if (priceEl && option.dataset.price) priceEl.textContent = option.dataset.price;

    if (compareEl) {
      if (option.dataset.comparePrice) {
        compareEl.textContent = option.dataset.comparePrice;
        compareEl.classList.remove('is-hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('is-hidden');
      }
    }

    if (addBtn) {
      addBtn.disabled = !isAvailable;
      addBtn.textContent = isAvailable ? 'Add to cart' : 'Sold out';
    }
  }
});

// Product gallery. Auto-advances every 3 seconds when the page opens.
// Autoplay stops for good as soon as the customer picks a variant (the photo
// then stays on that variant), and also when they browse the photos
// themselves (arrows, thumbnails, swipe). A page opened on a ?variant= link
// shows that variant's photo and does not autoplay. Reduced-motion users
// never get autoplay; it also pauses while the tab is in the background.
function initProductGallery(gallery) {
  const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
  const prevBtn = gallery.querySelector('[data-gallery-prev]');
  const nextBtn = gallery.querySelector('[data-gallery-next]');
  const currentEl = gallery.querySelector('[data-gallery-current]');
  if (!slides.length) return;

  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) index = 0;

  const goTo = (nextIndex) => {
    if (nextIndex < 0) nextIndex = slides.length - 1;
    if (nextIndex >= slides.length) nextIndex = 0;
    index = nextIndex;

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === index);
    });
    thumbs.forEach((thumb, thumbIndex) => {
      thumb.classList.toggle('is-active', thumbIndex === index);
    });
    if (currentEl) currentEl.textContent = String(index + 1);
  };

  const AUTOPLAY_MS = 3000;
  const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer = null;
  let stopped = false;

  const stopAutoplay = () => {
    stopped = true;
    if (timer) { clearInterval(timer); timer = null; }
  };
  const startAutoplay = () => {
    if (stopped || reduceMotion || slides.length < 2) return;
    if (timer) clearInterval(timer);
    timer = setInterval(() => {
      if (!document.hidden) goTo(index + 1);
    }, AUTOPLAY_MS);
  };

  gallery.lfStopAutoplay = stopAutoplay;
  gallery.lfGoToKey = (key) => {
    if (!key) return false;
    const i = slides.findIndex((s) => s.getAttribute('data-image-key') === key);
    if (i < 0) return false;
    stopAutoplay();
    goTo(i);
    return true;
  };

  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => { stopAutoplay(); goTo(Number(thumb.dataset.index)); });
  });

  if (prevBtn) prevBtn.addEventListener('click', () => { stopAutoplay(); goTo(index - 1); });
  if (nextBtn) nextBtn.addEventListener('click', () => { stopAutoplay(); goTo(index + 1); });

  let touchStartX = 0;
  const viewer = gallery.querySelector('.product-gallery__viewer');
  if (viewer) {
    viewer.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0].clientX;
    }, { passive: true });

    viewer.addEventListener('touchend', (event) => {
      const diff = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) < 40) return;
      stopAutoplay();
      if (diff < 0) goTo(index + 1);
      else goTo(index - 1);
    }, { passive: true });
  }

  // Any variant button on the page stops the slideshow.
  document.addEventListener('click', (event) => {
    if (event.target.closest && event.target.closest('[data-lfopt-btn]')) stopAutoplay();
  }, true);

  // Arrived on a specific variant link: stay on it.
  try {
    if (new URL(window.location.href).searchParams.get('variant')) stopAutoplay();
  } catch (e) {}

  goTo(index);
  startAutoplay();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);

  // AutoDS and marketplace descriptions often import a generic heading that
  // duplicates the theme's own Description accordion label. Hide only that
  // redundant heading; preserve all meaningful headings in the description.
  document.querySelectorAll('.product-description-clean h1, .product-description-clean h2, .product-description-clean h3, .product-description-clean h4, .product-description-clean h5, .product-description-clean h6').forEach((heading) => {
    const label = heading.textContent.trim().toLowerCase().replace(/[:\s]+$/g, '');
    if (label === 'product description' || label === 'description') {
      heading.hidden = true;
    }
  });
});

// The currency converter app only converts amounts inside <span class="money">.
// The product buy box and the cart print bare amounts (and the variant picker
// rewrites them as plain text), so they stayed in USD while the rest of the
// page showed the visitor's currency. Wrap them, and re-wrap after rewrites.
(function () {
  var SEL = '[data-lf-price],[data-lf-compare],[data-lf-save],.cart-item__price strong,.cart-summary__line strong';
  var RX = /\$\s?\d[\d,]*(?:\.\d{1,2})?/;
  function wrap(el) {
    if (el.querySelector('.money')) return;
    var t = el.textContent;
    var m = t.match(RX);
    if (!m) return;
    var s = document.createElement('span');
    s.className = 'money';
    s.textContent = m[0];
    el.textContent = '';
    el.append(t.slice(0, m.index), s, t.slice(m.index + m[0].length));
  }
  function run() {
    document.querySelectorAll(SEL).forEach(function (el) {
      wrap(el);
      if (!el.__lfMoney) {
        el.__lfMoney = new MutationObserver(function () { wrap(el); });
        el.__lfMoney.observe(el, { childList: true });
      }
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
})();
